import { FC, useContext, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import withAuthenticationRequired from '../../Auth/withAuthenticationRequired';
import Sidebar from '../../Sidebar';
import PluginDiv from './PluginDiv';
import { FileSystemContext } from '../../FileSystem';
import { FilePond } from 'react-filepond';
import apiUrl from '../../../assets/apiUrl';
import { getAccessToken } from '../../Auth';
import { Button } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { remove } from '../../../api/File';

const Plugins: FC = () => {
  const { useFiles, useFolders } = useContext(FileSystemContext);
  const [folders] = useFolders();
  const [files, setFiles] = useFiles();
  const [pluginFolder, setPluginFolder] = useState<string>('');
  useEffect(() => {
    const folder = folders.find(
      (e) => e.title === '.plugins' && e.parent_folder === null
    );
    if (!folder) return;
    setPluginFolder(folder.folder_uid);
  }, [folders]);
  const [token, setToken] = useState<string>();
  useEffect(() => {
    const refreshToken = () => getAccessToken().then((res) => setToken(res));
    const handle = setInterval(refreshToken, 840000);
    refreshToken();
    return () => {
      clearInterval(handle);
    };
  }, []);
  const [selectedPlugins, setSelectedPlugins] = useState<string[]>([]);
  const onSelection = (file_uid: string, value: boolean) => {
    if (!value) {
      return setSelectedPlugins((state) => state.filter((e) => e !== file_uid));
    }
    setSelectedPlugins((state) => [...state, file_uid]);
  };
  const performDeletion = async () => {
    for (const plugin of selectedPlugins) {
      remove(plugin, await getAccessToken(), () =>
        setFiles((state) => state.filter((e) => e.file_uid !== plugin))
      );
    }
    setSelectedPlugins([]);
  };
  const FilePondRef = useRef<any>();
  return (
    <div className={styles.Plugins}>
      <Sidebar />
      <div className={styles.Container}>
        <FilePond
          ref={FilePondRef}
          onprocessfile={(error, file) => {
            if (error) {
              console.log('there was an error');
            } else {
              setTimeout(() => {
                FilePondRef.current.removeFile(file.id);
              }, 3000);
            }
          }}
          allowMultiple={false}
          server={{
            url: `${apiUrl}/file?folder_uid=${pluginFolder}`,
            headers: {
              'x-access-token': token || '',
            },
          }}
          name="uploads"
          labelIdle='Drag & Drop your plugin or <span class="filepond--label-action">Browse</span>'
        />
        <table>
          <Button
            color="secondary"
            startIcon={<Delete />}
            style={{ opacity: selectedPlugins.length > 0 ? '1' : '0' }}
            onClick={() => performDeletion()}
          >
            Delete
          </Button>
          <tr className={styles.TableHeader}>
            <th></th>
            <th>Name</th>
          </tr>
          {files
            .filter((e) => e.folder_uid === pluginFolder)
            .map((e) => (
              <PluginDiv file_uid={e.file_uid} onSelection={onSelection} />
            ))}
        </table>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(Plugins);
